import type { LegalSection } from './legalTypes';

/** Cookie details (also linked from Privacy Policy #cookies). */
export const cookiePolicySections: LegalSection[] = [
  {
    title: 'Essential',
    paragraphs: [
      'Required for sign-in and security. Provided by Firebase Authentication. These cannot be disabled while using an account.',
    ],
  },
  {
    title: 'Analytics',
    paragraphs: [
      'Firebase Analytics (Google) helps us understand how the site is used. Loaded only if you click "Accept all" on the cookie banner. You may choose "Essential only" to decline analytics cookies.',
    ],
  },
  {
    title: 'Your choices',
    paragraphs: [
      'Use the cookie banner on first visit or "Cookie settings" in the footer to update preferences. Clearing browser storage will reset your choice and show the banner again.',
    ],
  },
];
